// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"use-iteration-editor-module__SanitizedHtml__MGauK"};